import { fetchInstance } from "@/utils/fetchInstance";
import type { Transaction, TransactionSource } from "@/models/transaction/Transaction";

export type TransactionSort =
  | "created_at"
  | "-created_at"
  | "amount"
  | "-amount"
  | "amount_after_discount"
  | "-amount_after_discount";

export interface GetMyTransactionsParams {
  /** When true, also include direct in-miniapp purchases (source = 2). */
  include_miniapp_direct?: boolean;
  per_page?: number;
  page?: number;
  filter?: {
    status?: "completed";
    /** Narrows within what include_miniapp_direct already allows. */
    source?: TransactionSource;
    /** YYYY-MM-DD range on `created_at`. */
    date?: {
      from?: string;
      to?: string;
    };
    /** true = paid only, false = free only. */
    paid?: boolean;
  };
  /** Defaults server-side to `-created_at`. */
  sort?: TransactionSort;
}

export class TransactionService {
  static async getMyTransactions(params?: GetMyTransactionsParams) {
    const searchParams = new URLSearchParams();

    searchParams.set("include_miniapp_direct", "false");
    if (typeof params?.per_page === "number") {
      searchParams.set("per_page", String(params.per_page));
    }
    if (typeof params?.page === "number") {
      searchParams.set("page", String(params.page));
    }

    const f = params?.filter;
    if (f?.status) {
      searchParams.set("filter[status]", f.status);
    }
    if (typeof f?.source === "number") {
      searchParams.set("filter[source]", String(f.source));
    }
    if (f?.date?.from) {
      searchParams.set("filter[date][from]", f.date.from);
    }
    if (f?.date?.to) {
      searchParams.set("filter[date][to]", f.date.to);
    }
    if (typeof f?.paid === "boolean") {
      searchParams.set("filter[paid]", f.paid ? "true" : "false");
    }

    if (params?.sort) {
      searchParams.set("sort", params.sort);
    }

    const queryString = searchParams.toString();
    const endpoint = `vitrin/my-transactions${queryString ? `?${queryString}` : ""}`;

    return fetchInstance<Transaction[]>(endpoint, {
      method: "GET",
      auth: true,
    });
  }
}
